export interface UploadResponse {
  url: string; // De URL van de geüploade blob
  message: string;
}

/**
 * Upload een bestand naar Azure Blob Storage via Function App
 */
export async function uploadFileRequest(
  file: File,
  containerName: string,
): Promise<UploadResponse> {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`/api/uploadFile?container=${containerName}`, {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`Error uploading file: ${response.statusText} - ${errorText}`);
  }

  return response.json();
}

/**
 * Upload meerdere bestanden tegelijk
 */
export async function uploadMultipleFiles(
  files: File[],
  containerName: string,
): Promise<UploadResponse[]> {
  const results: UploadResponse[] = [];

  for (const file of files) {
    const result = await uploadFileRequest(file, containerName);
    results.push(result);
  }

  return results;
}
